import { OneGateLogo_3Icon } from "@dataone/icons";
import { styled } from "styled-components";
interface ErrorStepProps {
  errorMessage?: any;
}

export const ErrorStep = ({ errorMessage }: ErrorStepProps) => {
  return (
    <StyledErrorStep>
      <StyledErrorIcon>
        <OneGateLogo_3Icon />
      </StyledErrorIcon>
      <h3>
        {errorMessage}
        <br /> Please check again
      </h3>
    </StyledErrorStep>
  );
};

const StyledErrorStep = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 15%;
  // width: 40vw;

  h3 {
    text-align: center;
  }
`;
const StyledErrorIcon = styled.div`
  font-size: 100px;
  color: #fb5050;
  display: flex;
`;
